import Grid from '@mui/material/Grid';
import ExpandableBar from 'components/ExpandableBar';
import LcsSelectorEvaluationProduct from 'connectedComponents/HeaderButtons/LcsSelectorEvaluationProduct';
import ScenarioSelector from 'connectedComponents/HeaderButtons/ScenarioTableSelector';
import React, { useEffect, useState } from 'react';
import theme from 'source/theme';

const Component = props => {
  const {
    currentOptionProduct, currentOptionLcs, currentOptionScenario, scenarios
  } = props;
  const {
    closeScenarioManagement, onSelectionScenario, onSelectionLcs
  } = props;


  const scenarioText = () =>
    <span>
      <span style={{ backgroundColor: theme.palette.primary.main, borderRadius: '5px', paddingTop: 3 }}>&nbsp;PRODUTO&nbsp;</span>
      &nbsp;{currentOptionProduct['name']}&nbsp;
      <span style={{ backgroundColor: theme.palette.primary.main, borderRadius: '5px', paddingTop: 3 }}>&nbsp;LCS&nbsp; </span>
      &nbsp;{currentOptionLcs['description']}&nbsp;
      <span style={{ backgroundColor: theme.palette.primary.main, borderRadius: '5px', paddingTop: 3 }}>&nbsp;CENÁRIO&nbsp;</span>
      &nbsp;{currentOptionScenario && currentOptionScenario['code']}&nbsp;
    </span>;

  return (
    <ExpandableBar
      header=''
      text={scenarioText}
      goBack={closeScenarioManagement}
    >
      <Grid container>
        <Grid size={12} style={{ marginBottom: 5 }}>
        </Grid>
        <Grid size={12} style={{ marginBottom: 5 }}>
          <LcsSelectorEvaluationProduct
            currentOption={currentOptionLcs}
            onSelection={onSelectionLcs}
            product={currentOptionProduct}
          />
        </Grid>
        <Grid size={12} style={{ marginBottom: 5 }}>
          <ScenarioSelector
            currentOption={currentOptionScenario}
            onSelection={onSelectionScenario}
            options={scenarios}
          />
        </Grid>
      </Grid>
    </ExpandableBar>
  );
};

export default Component;
